import { Details } from 'nhsuk-react-components';
import { IterationRuleWithAndClauses } from '../../../utils/ruleUtils.ts';

interface RuleRowListValuesProps {
    rule: IterationRuleWithAndClauses;
}

export default function RuleRowListValues({
  rule,
}: RuleRowListValuesProps) {
  const isEmptyComparator = !rule.Comparator || rule.Comparator === '';
  const itemCount = isEmptyComparator ? 0 : rule.Comparator?.split(',').length ?? 0;
  const listValues = isEmptyComparator ? '' : rule.Comparator?.split(',').map((v) => v.trim()).join(', ') ?? '';
  return (
    <Details className="nhsuk-u-margin-top-2 nhsuk-u-margin-bottom-2">
      <Details.Summary>
        {itemCount}
        {' '}
        {itemCount === 1 ? 'item' : 'items'}
      </Details.Summary>
      <Details.Text>
        {listValues}
      </Details.Text>
    </Details>
  );
}
